
<div class="min-h-screen flex justify-center items-center">
    <div class="">
        <div class="text-center font-semibold">
            <h1 class="text-5xl">
                <span class="text-blue-700 tracking-wide">Flexible </span>
                <span class="text-gray-50">Hosting</span>
            </h1>
            <p class="pt-6 text-xl text-gray-400 font-normal w-full px-8 md:w-full">
                Choose the plan that works best for your needs.
            </p>
        </div>
        <div class="pt-24 flex flex-row">
            
            <div class="mx-auto w-90 p-9 bg-gray-900 text-center rounded-3xl text-white border-4 shadow-xl transform scale-125 border-red-400 border-5">
                <h1 class="text-white font-semibold text-2xl">Premium {name}</h1>
                <p class="pt-2 tracking-wide">
                    <span class="text-gray-400 align-top">$ </span>
                    <span class="text-3xl font-semibold">{price}</span>
                    <span class="text-gray-400 font-medium">/ month</span>
                </p>
                <hr class="mt-4 border-1 border-gray-600">
                <div class="pt-8">
                                              <ul class="text-sm text-gray-100 w-full mt-6 mb-6">
    <li class="mb-3 flex items-center from-yellow-600 to-red-500 bg-gradient-to-r rounded-md p-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
            
        {cpu}
    </li>
    <li class="mb-3 flex items-center from-green-600 to-purple-500 bg-gradient-to-r rounded-md p-2">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.75 8.75C6.75 7.64543 7.64543 6.75 8.75 6.75H15.25C16.3546 6.75 17.25 7.64543 17.25 8.75V15.25C17.25 16.3546 16.3546 17.25 15.25 17.25H8.75C7.64543 17.25 6.75 16.3546 6.75 15.25V8.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M9.75 4.75V6.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M19.25 9.75L17.75 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M9.75 17.75V19.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M6.25 9.75L4.75 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M14.25 4.75V6.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M19.25 14.25L17.75 14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M14.25 17.75V19.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M6.25 14.25L4.75 14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
            
          {ram}
    </li>
    <li class="mb-3 flex items-center from-blue-600 to-red-500 bg-gradient-to-r rounded-md p-1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.75 11.75H19.25V18.25C19.25 18.8023 18.8023 19.25 18.25 19.25H5.75C5.19771 19.25 4.75 18.8023 4.75 18.25V11.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M4.75 14V11.9068C4.75 11.8029 4.76618 11.6996 4.79797 11.6008L6.77693 5.44399C6.90986 5.03044 7.29457 4.75 7.72896 4.75H16.271C16.7054 4.75 17.0901 5.03044 17.2231 5.44399L19.202 11.6008C19.2338 11.6996 19.25 11.8029 19.25 11.9068V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M7.75 15.25H9.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12.75 15.25H16.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            
            Unmetered NvME SSD
    </li>
    <li class="mb-3 flex items-center text-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
        </svg>
            
        10 Databases
    </li>
    <li class="mb-3 flex items-center text-gray-100">
        <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.25 17.25V9.75C19.25 8.64543 18.3546 7.75 17.25 7.75H4.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25Z"></path>
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.5 7.5L12.5685 5.7923C12.2181 5.14977 11.5446 4.75 10.8127 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V11"></path>
          </svg>
          
            
        10 Backups
    </li>
    <li class="mb-3 flex items-center text-gray-100">
        <svg class="h-6 w-6 mr-2" xmlns="http://www.w3.org/2000/svg" width="6" height="6" stroke="currentColor" fill="#10b981" viewBox="0 0 1792 1792">
            <path d="M1412 734q0-28-18-46l-91-90q-19-19-45-19t-45 19l-408 407-226-226q-19-19-45-19t-45 19l-91 90q-18 18-18 46 0 27 18 45l362 362q19 19 45 19 27 0 46-19l543-543q18-18 18-45zm252 162q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z">
            </path>
        </svg>
        Premium Panel
    </li>
</ul>

<a href="{paypalLink}" class="">
    <p class="w-full py-4 bg-gradient-to-r from-blue-500 to-blue-700 mt-8 rounded-xl text-white">
        <span class="font-medium">
            Checkout with PayPal
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" class="inline h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
    </p>
</a>
                      <a href="{paymentLink}" class="">
                        <p class="w-full p-5 py-4 bg-gradient-to-r from-red-500 to-purple-700 mt-8 rounded-xl text-white">
                            <span class="font-medium">
                                Checkout with Credit Card
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" class="inline h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
</svg>
                        </p>
                    </a>
                </div>
                <div class="absolute top-0 w-90 left-5 right-5 m-1 p-0">
                    <p class="bg-gradient-to-r from-yellow-500 to-red-500 font-semibold px-4 py-1 rounded-full uppercase text-xs"><svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
</svg>MOST POPULAR</p>
                </div>
            </div>
            
        </div>
    </div>
</div>


<script>
    export let name;
    export let price;
    export let cpu;
    export let ram;
    export let paymentLink;
    export let paypalLink;
</script>
